import { render, staticRenderFns } from "./SGuide.vue?vue&type=template&id=2fb854f2"
import script from "./SGuide.vue?vue&type=script&lang=js"
export * from "./SGuide.vue?vue&type=script&lang=js"
import style0 from "./SGuide.vue?vue&type=style&index=0&id=2fb854f2&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports